import React from 'react';
import AffiliateList from '../components/affiliate/AffiliateList';
import { getBlackBelts, getBlackBeltByName } from '../view/HTTPService';

/**
 * /blackbeltsByName - Faixas pretas com busca por nome.
 * Carrega todas as faixas pretas por padrão e permite buscar por nome.
 */
export default function BlackbeltsByNamePage() {
    return (
        <AffiliateList
            titleKey="msg.jkaBlackBeltsByName"
            fetchAffiliates={getBlackBelts}
            searchByName={getBlackBeltByName}
        />
    );
}
